import { Model } from "survey-core";
import { normalisePostalCode } from "./normalisePostalCode";

export const addressLookup = async (survey: Model) => {
  if (!survey.api) {
    console.warn(
      "No API client available on survey object for address lookup.",
    );
    return;
  }

  const postalCode = normalisePostalCode(
    String(survey.getValue("postalCode") ?? ""),
  );
  const streetNumber = String(survey.getValue("streetNumber") ?? "")?.trim();
  const addition = survey.getValue("streetNumberAddition")?.trim();

  if (!postalCode || !streetNumber) {
    return;
  }

  const streetQuestion = survey.getQuestionByName("street");
  const cityQuestion = survey.getQuestionByName("city");

  if (!streetQuestion || !cityQuestion) {
    console.warn(
      "Street or city question not found in form for address lookup.",
    );
    return;
  }

  survey.setValue("postalCode", postalCode);
  survey.setValue("streetNumber", streetNumber);
  if (addition) survey.setValue("streetNumberAddition", addition);

  streetQuestion.readOnly = true;
  cityQuestion.readOnly = true;

  await survey.api
    .get(
      `/location?country=NL&postalCode=${postalCode}&streetNumber=${streetNumber}${addition ? `&streetNumberAddition=${addition}` : ""}`,
    )
    .then((response) => {
      const { street, city } = response.data ?? {};

      survey.setValue("street", street ?? undefined);
      survey.setValue("city", city ?? undefined);
    })
    .catch(() => {
      streetQuestion.readOnly = false;
      cityQuestion.readOnly = false;
    });
};
